const KEY = "invite_destination";

/** Store the chat path an invited user should land on after auth. */
export function setInviteDestination(path: string): void {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {}
}

/** Get the stored invite destination, if any. */
export function getInviteDestination(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/** Clear the invite destination (after user navigates away). */
export function clearInviteDestination(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
}
